// extracted by mini-css-extract-plugin
export default {"text":"_3C3wK","button":"_2Y8o5"};